import { ccwpApi } from "@/services";
import { DELETE_UNIT } from "../constant/apiPath";
import { maxPageSize } from "@/Constant";
// Define a service using a base URL and expected endpoints
export const GetUnitByCaseIdApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getUnits: builder.query<any, any>({
      query: (caseId) => ({
        url: "Unit/GetUnitByCaseId",
        method: "GET",
        params: { caseId, pageSize: maxPageSize },
      }),
      transformResponse: (response: any) => {
        if (response?.results) {
          return response?.results;
        } else {
          return response;
        }
      },
    }),
    getUnitsListData: builder.query<any, any>({
      query: (paramsData) => ({
        url: "Unit/GetUnitByCaseId",
        method: "GET",
        params: { ...paramsData },
      }),
    }),
    createUnit: builder.mutation({
      query: (data) => ({
        url: "Unit/CreateUnit",
        method: "POST",
        body: data,
      }),
    }),
    updateUnit: builder.mutation({
      query: (data) => ({
        url: "Unit/UpdateUnit",
        method: "PUT",
        body: data,
      }),
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetUnitsQuery,
  useGetUnitsListDataQuery,
  useLazyGetUnitsQuery,
  useCreateUnitMutation,
  useUpdateUnitMutation,
} = GetUnitByCaseIdApi;

export const GetCommentByClaimItemIdApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getCommentByClaimItemId: builder.query<any, any>({
      query: (claimId) => `Comment/ListCommentsByEntity?EntityId=${claimId}`,
    }),
  }),
});
export const { useGetCommentByClaimItemIdQuery } = GetCommentByClaimItemIdApi;

const DeleteUnitApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteUnit: builder.mutation<any, any>({
      query: (unitId) => ({
        url: DELETE_UNIT + unitId,
        method: "DELETE",
      }),
    }),
  }),
});

export const { useDeleteUnitMutation } = DeleteUnitApi;
